import {Injectable} from '@angular/core';
import {AbstractCrudService} from '../../shared/abstract-crud.service';
import {Subject} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {LegacyAppVersion} from './legacy-app-version.model';

// TODO: delete legacy service once the new update system has been deployed
@Injectable({
  providedIn: 'root'
})
export class LegacyAppVersionService extends AbstractCrudService<LegacyAppVersion> {

  private appUpdates = new Subject<LegacyAppVersion>();
  public appUpdates$ = this.appUpdates.asObservable();

  /**
   * URL for current model
   * @type {string}
   */
  protected url = environment.apiURL + 'appversion';

  constructor(http: HttpClient) {
    super(http);
  }
}
